import { id } from "date-fns/locale";
import Translator from "../../../requests/apa/Translator";
import RequestManager from "../../../requests/RequestManager";
import MatchesTask from "../../../requests/tasks/sports/matchesTask";
import Utils from "../../../utils/Utils";
import { lettersTabs } from "../Paises/constants";
import logger from 'src/utils/logger/logger';

export const getMatchesStatistics = async (leagueId, matchId, view = 'all') => {
    try {
        const matchesTask = new MatchesTask(leagueId, matchId, view);
        const response = await RequestManager.addRequest(matchesTask);
        if(!response) return [];
        return response.response;
    }catch (error) {
        logger.error('Error getting countries:', error);
        return { countries: [], tabs: [] };
    }
}



// WEBPACK FOOTER //
// ./src/containers/Mundial2026/services/getMatchesStatistics.js